export function careerProfilePathFromLegacy(pathname: string, search = ""): string {
  return `${pathname.replace("/career-plan", "/career-profile")}${search}`;
}
